<script setup>
import { onBeforeMount, ref } from 'vue'
import { useAuthStore } from '../stores/auth.store'

let auth_string = useRoute().params.auth_string
//let doc_loaded = ref(false)

const $auth = useAuthStore()

let username = ref($auth.user)
let password = ref('')

// Methods
async function Login() {
  $auth.login(username.value, password.value)
}
// Handlers
onBeforeMount(async () => {})
</script>

<template>
  <v-container>
    <h1>Авторизация</h1>
    <v-text-field v-model="username" label="Имя пользователя"></v-text-field>
    <v-text-field v-model="password" type="password" label="Пароль"></v-text-field>
    <v-btn prepend-icon="mdi-login" @click="Login"> Войти </v-btn>
  </v-container>
</template>

<style lang="less" scoped>
.loader {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    margin-left: 10px;
    font-size: 1.2rem;
  }
}
</style>
